export const CHECKOUT_URL = 'https://italiano-ready.impultienda.ar/checkout'
